/** Offset for the fixed site header (+ small breathing room). */
const HEADER_OFFSET_PX = 88;

/**
 * Scroll so the booking flow stays in view after a step change.
 * Prefer an in-page anchor so the viewport does not land on the site footer
 * when the next step is shorter than the previous one.
 */
export function scrollBookingIntoView(anchor?: HTMLElement | null): void {
  const run = () => {
    if (anchor) {
      const top = anchor.getBoundingClientRect().top + window.scrollY - HEADER_OFFSET_PX;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      return;
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // Double rAF: wait until the new step has painted (height may shrink).
  requestAnimationFrame(() => {
    requestAnimationFrame(run);
  });
}
